import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { BaseComponent, UserService } from "@mypxplat/xplat/core";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "fui-heading",
  templateUrl: "heading.component.html",
  standalone: false,
})
export class FuiHeadingComponent extends BaseComponent implements OnInit {
  @Input() text: string;
  @Input() color: string;
  @Input() fontSize: string;
  @Input() extraClasses: string;
  @Input() level: string | number = "1";
  @Input() textAlign: string = "left";
  public value: string;
  public styles: { [key: string]: string } = {};

  constructor(userService: UserService) {
    super(userService);
  }

  ngOnInit(): void {
    this.value = "fui-heading-" + this.level;
    if (this.extraClasses) {
      this.value = this.value + " " + this.extraClasses;
    }
    if (this.fontSize) {
      this.styles["font-size"] = `var(--font-sizes-${this.fontSize})`;
    }
    if (this.color) {
      this.styles["color"] = this.color;
    }
    this.styles["text-align"] = this.textAlign;
  }
}
